import React from 'react';
import { graphql } from 'gatsby';
import { withPrismicPreview } from 'gatsby-plugin-prismic-previews';
import Post, { PostProps } from '@components/post';

const BlogPostPage = ({ data }: PostProps): JSX.Element => <Post data={data} />;

export default withPrismicPreview(BlogPostPage);

export const query = graphql`
  query BlogPostQuery($uid: String, $categoriesArray: [String]) {
    prismicGeneralConfig {
      data {
        favicon {
          url
        }
      }
    }
    prismicPostPageConfig {
      ...PostPageConfigFragment
    }
    currentPost: allPrismicBlogPost(filter: { uid: { eq: $uid } }) {
      edges {
        node {
          ...BlogPostFragment
        }
      }
    }
    relativePosts: allPrismicBlogPost(
      filter: { tags: { in: $categoriesArray }, uid: { ne: $uid } }
      limit: 3
      sort: { fields: first_publication_date, order: DESC }
    ) {
      edges {
        node {
          ...BlogPostPreviewFragment
        }
      }
    }
    restPosts: allPrismicBlogPost(
      filter: { uid: { ne: $uid } }
      limit: 3
      sort: { fields: first_publication_date, order: DESC }
    ) {
      edges {
        node {
          ...BlogPostPreviewFragment
        }
      }
    }
  }
`;
